module.exports = __webpack_public_path__ + "static/media/super-jads.b96d7f36.png";